import * as Sentry from '@sentry/nuxt';
import { SENTRY_APPLICATION_KEY } from '../assets/constants';
import type { Client, VisaForm } from '~/types';
import { getEnvName } from './environment';

export function initSentry(context: 'server' | 'client') {
  Sentry.init({
    // Why it's here: https://docs.sentry.io/platforms/javascript/guides/nuxt/#server-side-setup
    dsn: 'https://dddad8e70f57bc4aac967fedf32d8ed4@o4507249649385472.ingest.de.sentry.io/4507249655087184',
    tracesSampleRate: 1.0,
    environment: getEnvName(),
    enableLogs: true,
    integrations: [
      ...(context == 'server' ? [] : [
        Sentry.thirdPartyErrorFilterIntegration({
          filterKeys: [SENTRY_APPLICATION_KEY],
          behaviour: 'drop-error-if-contains-third-party-frames'
        })
      ])
    ]
  });
}

export function setSentryUser(formId: VisaForm['id'], user: Client) {
  Sentry.setUser({
    id: formId,
    email: user.email,
    username: user.name
  });
}